import { EnderecoIcon } from "assets/iconsSVG/enderecoIcon";
import * as Styles from "./style";
import * as iconSVG from "../../../../assets/iconsSVG";

interface Props {
  data: any;
}
export function Endereco(props: Readonly<Props>) {
  return (
    <Styles.Container>
      <Styles.Card>
        <Styles.HeaderCard>
          <Styles.IconHeader>
            <EnderecoIcon />
          </Styles.IconHeader>
          <div>
            <Styles.Text>Plantão</Styles.Text>
            <Styles.SubtitleHeader
              style={{ textDecoration: "none" }}
              href={props?.data?.pdv?.urlGoogleMaps || "#"}
              target="_blank"
            >
              {props?.data?.pdv?.logradouro || "--"}
              <iconSVG.ExternalLinkWhite viewBox="0 -3 29 16" color="#2D5BFF" />
            </Styles.SubtitleHeader>
            <Styles.Subtitle>
              {props?.data?.pdv?.bairro || "--"},{" "}
              {(props?.data?.pdv?.estado || "--").toUpperCase()}
            </Styles.Subtitle>
          </div>
        </Styles.HeaderCard>
        <Styles.SubCard>
          <Styles.SubCardTitle>
            {props?.data?.pdv?.temDecorado === true
              ? "Este produto possui decorado"
              : "Este produto não possui decorado"}
          </Styles.SubCardTitle>
        </Styles.SubCard>
      </Styles.Card>
    </Styles.Container>
  );
}
